export default "/_next/static/images/87aaa322537c96e462ebf8142f151a03.jpg";